import { render, staticRenderFns } from "./by-group.vue?vue&type=template&id=5634bc60&scoped=true"
import script from "./by-group.vue?vue&type=script&lang=ts"
export * from "./by-group.vue?vue&type=script&lang=ts"
import style0 from "./by-group.vue?vue&type=style&index=0&id=5634bc60&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634bc60",
  null
  
)

export default component.exports